module.exports = __webpack_public_path__ + "img/michaela.74b3e467.png";